import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Chip } from '@mui/material';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { COLORS } from '../../../constants/radar';

const CVSectionsChecklist = ({ sections }) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      gap: 1.5,
    }}>
      {sections.map((section, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            color: section.complete ? '#059669' : '#DC2626',
            fontSize: '0.875rem',
            py: 0.5,
            '&:not(:last-child)': {
              borderBottom: '1px solid #f1f5f9'
            }
          }}
        >
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 20,
            height: 20,
            borderRadius: '50%',
            bgcolor: section.complete ? '#dcfce7' : '#fee2e2',
            color: section.complete ? '#059669' : '#DC2626',
          }}>
            {section.complete ? (
              <FaCheck size={10} />
            ) : (
              <FaTimes size={10} />
            )}
          </Box>
          <Typography
            sx={{
              color: '#334155',
              fontSize: '0.875rem',
              fontWeight: 500,
              flex: 1,
            }}
          >
            {section.name}
          </Typography>
          {section.items !== null && section.items !== undefined && (
            <Chip
              label={section.items}
              size="small"
              sx={{
                height: '20px',
                minWidth: '20px',
                fontSize: '0.7rem',
                fontWeight: '600',
                borderRadius: '10px',
                bgcolor: section.complete ? '#dcfce7' : '#f1f5f9',
                color: section.complete ? '#059669' : '#64748b',
                border: section.complete ? '1px solid #a7f3d0' : '1px solid #e2e8f0',
                px: 0.5,
              }}
            />
          )}
        </Box>
      ))}
    </Box>
  );
};

CVSectionsChecklist.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      complete: PropTypes.bool.isRequired,
      items: PropTypes.number
    })
  ).isRequired
};

export default CVSectionsChecklist; 